import store from "store2"

export default function(type,size){

  var s = store.namespace('omb')

  var dataServer = s('dataServer')
  var thumbServer = s('thumbServer')
  var videoServer = s('videoServer')
  var assetServer = s('assetServer')
  var subServer = s('subServer')
  var fileServer = s('fileServer')
  var soundServer = s('soundServer')

  var url = null

  if(type == 'sequence'){
    url = `${videoServer}stream/sequence/${size}/`
  } else if (type == 'watermark') {
    url = `${videoServer}stream/watermark/${size}/`
  } else if (type == 'archive') {
    url = `${videoServer}stream/archive/${size}/`
  } else if (type == 'downloadWatermark') {
    url = `${videoServer}downloadWatermark/${size}/`
  } else if (type == 'downloadScreenshotWatermark') {
    url = `${thumbServer}downloadScreenshotWatermark/`
  } else if (type == 'thumb'){
    url = `${thumbServer}thumb/${size}/`
  } else if (type == 'thumbAntiArchive'){
    url = `${thumbServer}thumbAntiArchive/${size}/`
  } else if (type == 'movieThumb'){
    url = `${thumbServer}movieThumb/${size}/`
  } else if (type == 'movie'){
    url = `${videoServer}stream/movie/${size}/`
  } else if (type == 'asset'){
    url = `${assetServer}asset/`
  } else if (type == 'file'){
    url = `${fileServer}file/`
  } else if (type == 'sound'){
    url = `${soundServer}sound/`
  } else if (type == 'sub'){
    url = `${subServer}sub/`
  } else if (type == 'frontend'){
    url = `${dataServer}frontend/`
  }

  return url

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/util/getUrl/getUrl.js